import { RequirementTypes } from '@/enums/license-request';
import { LicenseDetailWithIds } from '@/interfaces/common/common.interface';
import { CompleteLicense } from '@/interfaces/dashboard/licenses';
import { Contracts } from '@/interfaces/new-license-request/new-license-request-interfaces';
import { Person } from '@/interfaces/person';
import { CreateRequirement, RequestDocuments } from '@/interfaces/requirement';
import { CommonService } from '@/services/common/common.service';
import { RequirementService } from '@/services/requirement/requirement.service';
import { BoxColors } from '@/shared/person-card/person-card.component';
import { SelectOption } from '@/shared/select/select.component.interface';
import { StoreState } from '@/store';
import { getCurrentUserData } from '@/store/login/selectors';
import { modalShow } from '@/store/modal/actions';
import { loaderAnimationHide, loaderAnimationShow } from '@/store/page-loader/action';
import { normalize } from '@/utils/normalizeString';
import { ofuscate } from '@/utils/obfuscation';
import { parseISOString } from '@/utils/parseISOString';
import { alLeastOneDateEndMustBeNotUndefined } from '@/validators/alLeastOneDateEndMustBeNotUndefined';
import { mustHaveOneRecord } from '@/validators/mustHaveOneRecord';
import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { map } from 'rxjs/operators';
import { RecordType } from '../../../../../interfaces/common/common.interface';
import { AssetsFilesService } from '@/services/assetsFilesService/assets-files.service';


type Variant = 'personal' | 'third';
@Component({
  templateUrl: './form.component.html',
  styleUrls: ['./form.component.css'],
})
export class FormComponent implements OnInit {

  variant: Variant = 'personal';
  requirementId: number = 0;
  licenseRequirementId: number = 0;
  personBoxColor: BoxColors = BoxColors.BROWN_GREY;
  selectedOption: RecordType = 'NONE';

  optionsSelectedContract: SelectOption[] = []
  currentUserData?: Person;
  license?: CompleteLicense;
  licenseZones?: number[][];
  person?: Person;
  licenseDetail?: LicenseDetailWithIds;
  selectedPersonIsEmployee: boolean = false;

  mdmid: string = '';
  assetId: number = 0;
  equipmentDataToSend?: RequestDocuments[];

  documentFormArray = new FormArray([], [mustHaveOneRecord(), alLeastOneDateEndMustBeNotUndefined()]);
  agreeTerms = new FormControl(false, [Validators.requiredTrue]);
  employeeFormControl = new FormGroup({
    managerFormControl: new FormControl('', [Validators.required]),
    superintendentFormControl: new FormGroup({
      filterText: new FormControl(''),
      id: new FormControl(0),
      mdmid: new FormControl(''),
    }),
  });

  contractFormControl: FormControl = new FormControl(null, [Validators.required]);
  contractOwnerForm = new FormControl('', [Validators.required]);

  canReuseOldDocs: boolean = true;

  get shouldEnableSubmit(): boolean {
    if (!this.selectedPersonIsEmployee) {
      return this.documentFormArray.valid && this.contractOwnerForm.valid;
    }
    // eslint-disable-next-line no-else-return
    else {
      return this.documentFormArray.valid && this.employeeFormControl.valid;
    }
  }

  constructor(
    private commonService: CommonService,
    private requirementService: RequirementService,
    private route: ActivatedRoute,
    private router: Router,
    private store: Store<StoreState>,
    private _location: Location,
    private assetsFilesService: AssetsFilesService,
  ) { }

  ngOnInit(): void {
    this.getParamsFromRouteState();
    getCurrentUserData(this.store).subscribe({
      next: (userData) => {
        this.currentUserData = userData;
        this.mdmid = userData.mdmid;
      },
    });
  }
  getParamsFromRouteState() {
    this.route.paramMap
      .pipe(map(() => window.history.state))
      .subscribe({
        next: (data) => {
          if (('license' in data)
            && ('licenseZones' in data)
            && ('person' in data)
            && ('variant' in data)
          ) {
            this.license = data.license;
            this.licenseRequirementId = data.license.requirementId;
            this.licenseZones = data.licenseZones;
            this.person = data.person;
            this.variant = data.variant;
            this.selectedPersonIsEmployee = normalize(this.person?.entity) === normalize('Employee');
            if (this.license) {
              this.canReuseOldDocs = !this.license.documents.every((doc) =>
                doc.dateEmit === '2021-10-25T03:00:00Z'
                || doc.dateFrom === '2021-10-25T03:00:00Z'
                || doc.dateUntil === '2021-10-25T03:00:00Z'
              );
              const equipmentsIds = this.license.equipments.map((equipment) => equipment.equipmentId);
              this.commonService.getLicenseDetailWithIds(this.license.id).subscribe({
                next: (res) => {
                  this.licenseDetail = { ...res, equipments: res.equipments.filter((equipment) => equipmentsIds.includes(equipment.equipmentId)) };
                  this.assetId = this.licenseDetail.assetId;
                  this.getContractsByAsset(this.assetId, this.licenseDetail.driverMdmid);
                  const registeredVehicles = this.licenseDetail.equipments;
                  this.equipmentDataToSend = registeredVehicles.map((vehicle) => ({
                    assetId: this.licenseDetail?.assetId as number,
                    equipmentId: vehicle.equipmentId,
                    vehicleTypeId: vehicle.vehicleType,
                    licenseType: vehicle.licenseTypes.join(),
                    conductionZone: vehicle.drivingAreas.join(),
                    brand: vehicle.brand,
                    model: vehicle.model,
                  }));
                },
                error: () => {
                  // this.licenseDetailError = 'Error al obtener el detalle de la licencia.';
                },
              });
              this.requirementService.requestNewId(RequirementTypes['Renovación Licencia'], this.license?.id).subscribe({
                next: (id) => {
                  this.requirementId = id;
                },
              });
            }
          }
          else {
            this._location.back();
          }
        },
        error: () => {
        },
      });
  }
  goBack() {
    this.router.navigateByUrl('/license/renew/third/select');
  }
  getContractsByAsset(assetId: number, mdmid: string) {

    this.requirementService
      .getContractByAsset(assetId, mdmid)
      .subscribe({
        next: (res) => {
          this.optionsSelectedContract = (<Required<Contracts>[]>res).map((contract): SelectOption => ({ id: contract.id, value: contract.name }));
        },
      });
  }

  showModalConfirmTermsAndConditions() {
    this.assetsFilesService.getTermsAndConditions().subscribe({
      next: (text) => {
        const parsedText = text.replace(/(?:\r\n|\r|\n)/g, '\\n');

        this.store.dispatch(
          modalShow({
            title: 'Términos y condiciones',
            text: parsedText,
            acceptButtonText: 'Aceptar',
            actionOnAccept: () => { },
          }),
        );
      },
    });
  }

  showCancelModal() {
    this.store.dispatch(
      modalShow({
        title: '¿Estas seguro de cancelar esta solicitud?',
        text: `
      La solicitud será cancelada automáticamente si continúa en cancelar solicitud. Presiona volver para regresar a la pantalla anterior.
      `,

        acceptButtonText: 'Cancelar solicitud',
        actionOnAccept: () => {
          this.router.navigateByUrl('../');
        },
      }),
    );
  }

  onSetContractOwner(mdmid: string) {
    this.contractOwnerForm.setValue(mdmid);
  }

  showConfirmationModal() {
    this.store.dispatch(
      modalShow({
        title: '¿Estas seguro de enviar esta solicitud?',
        text: `
        Si ya has revisado la información registrada y está correcta, continúa en Enviar la solicitud. De lo contrario, ingresa Volver para revisar la información.
      `,
        acceptButtonText: 'Enviar solicitud',
        actionOnAccept: () => {
          this.store.dispatch(loaderAnimationShow());
          if (this.equipmentDataToSend) {
            const equipments = this.equipmentDataToSend.map((equipment: RequestDocuments) => ({
              vehicleType: equipment.vehicleTypeId,
              brand: equipment.brand as string,
              model: equipment.model as string,
              licenseTypes: equipment.licenseType.split(',').map((id) => +id),
              drivingAreas: equipment.conductionZone.split(',').map((id) => +id),
              expiredAt: new Date(),
            }));

            const documentsFromArray: CreateRequirement['documents'] = this.documentFormArray.value.map((documentForm: any) => ({
              documentRequiredTypeId: documentForm.id,
              requirementId: <number>this.requirementId,
              fileName: documentForm.file.fileName,
              path: documentForm.file.fileUrl,
              createFrom: <Date>documentForm.dateFrom,
              createTo: <Date>documentForm.dateUntil,
              createAt: <Date>documentForm.dateEmit,
            }));

            const license = this.license!;

            const licenseDocumentsWithData = license.documents.filter((x) => !(
              x.dateEmit === '2021-10-25T03:00:00Z'
              || x.dateFrom === '2021-10-25T03:00:00Z'
              || x.dateUntil === '2021-10-25T03:00:00Z'
            ));

            const documentIdSet = new Set([...documentsFromArray.map((x) => x.documentRequiredTypeId), ...licenseDocumentsWithData.map((x) => x.documentRequiredTypeId)]);

            const documents: CreateRequirement['documents'] = [...documentIdSet].map((docId) => {
              const docFromFormArray = documentsFromArray.find(({ documentRequiredTypeId }) => docId === documentRequiredTypeId);
              if (docFromFormArray) {
                return docFromFormArray;
              }
              const docFromLicense = licenseDocumentsWithData.find(({ documentRequiredTypeId }) => docId === documentRequiredTypeId)!;
              return {
                documentRequiredTypeId: docFromLicense.documentRequiredTypeId,
                requirementId: <number>this.licenseRequirementId,
                fileName: docFromLicense.name,
                path: `${docFromLicense.id}`,
                createFrom: (!docFromLicense.dateFrom ? undefined : parseISOString(docFromLicense.dateFrom || '') as Date),
                createTo: (!docFromLicense.dateUntil ? undefined : parseISOString(docFromLicense.dateUntil || '') as Date),
                createAt: (!docFromLicense.dateEmit ? undefined : parseISOString(docFromLicense.dateEmit || '') as Date),
              };
            })
              .filter((doc: any) => ![58, 59].includes(doc.documentRequiredTypeId));

            // todo: borrar la siguient linea y descomentar lo de abajo
            // const params: any = {};
            const params: CreateRequirement = {
              equipments,
              requestorMdmid: this.currentUserData?.mdmid || '',
              assetId: this.licenseDetail?.assetId as number,
              contractOwnerMdmid: this.contractOwnerForm.value,
              documents,
              driverMdmid: this.person?.mdmid as string,
            };

            if (this.selectedPersonIsEmployee) {
              params.superintendenteRutDv = (this.employeeFormControl.controls.superintendentFormControl as FormGroup).controls.mdmid.value;
              params.requestManager = this.employeeFormControl.controls.managerFormControl.value;
            }

            this.requirementService.createRequirement(params, this.requirementId as number).subscribe({
              next: () => {
                const ofuscatedData = ofuscate({
                  email: this.person?.email,
                  userId: this.person?.id,
                  id: this.requirementId,
                  requestVariant: this.variant,
                });
                this.router.navigateByUrl(`/license/renew/result/${ofuscatedData}`);
                this.store.dispatch(loaderAnimationHide());
              },
              error: () => {
                this.store.dispatch(loaderAnimationHide());

                this.store.select('pageError').subscribe({
                  next: (pageConfig) => {
                    const [website, ...url] = window.location.href.split('//')[1].split('/');
                    if (pageConfig.errorType !== 'Mulesoft') {

                      const ofuscatedData = ofuscate({
                        variant: 'failure',
                      });
                      this.router.navigateByUrl(`/license/renew/result/${ofuscatedData}`);
                    }
                  },
                });

              },
            });
          }
        },
      }),
    );
  }
}
